module.exports = __webpack_public_path__ + "img/blog9.f42f9677.jpg";